




















































import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../../util/constants';
import { DateUtils } from '../../util/dateUtils';
import { ApiRequest } from '../../types/request';
import { ObjectFactory } from '../../config/objectFactory';
import { Route, ServiceRequest } from '../../types/entity';
import { CommonUtils } from '../../util/commonUtils';
import { RescheduleRequest } from '../../types/request';
import { ToastEvent } from '../../types/event';
import { EventBus } from '../../main';
import { required } from 'vuelidate/lib/validators';
import { MemberProfile } from '@/types/response';
// tslint:disable-next-line: no-var-requires
const TimeZones = require('../../config/timezones.json');
@Component({
    props: {
        request: Object,
    },
    validations: {
        requestDate: {
            required,
        },
    },
    data() {
        return {
            requestDate: '',
            requestTime: '',
            requestTimeZone: '',
        };
    },
})
export default class RescheduleRequestModal extends Vue {
    private show = false;
    private TimeZones = TimeZones;
    private routeId: any;
    private memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();
    private lastMinuteRequest = false;
    private confirmReschedule = false;

    public mounted() {
        const serviceRequest = this.$props.request as ServiceRequest;
        const date = DateUtils.formatDate(serviceRequest.appointment.timestamp, 'YYYY-MM-DD',
            serviceRequest.appointment.timezone);
        const time = DateUtils.formatDate(serviceRequest.appointment.timestamp, 'HH:mm',
            serviceRequest.appointment.timezone);
        this.$data.requestTimeZone = serviceRequest.appointment.timezone;
        this.$data.requestTime = time;
        this.$data.requestDate = date;
        this.show = true;
    }

    private close() {
        this.$router.go(-1);
    }

    private async handleReschedule() {
        const serviceRequest = this.$props.request as ServiceRequest;
        if (serviceRequest.transportRequest) {
            serviceRequest.transportRequest.routes.find((element) => {
                this.routeId = element.routeId;
            });
            await this.getRouteDetails(this.routeId, serviceRequest);
        }
        if (!this.lastMinuteRequest) {
            await this.rescheduleRequest();
        }
    }

    private async rescheduleRequest() {
        const iHttpService = ObjectFactory.getHttpService();
        const reschedule: RescheduleRequest = {
            appointmentDate: this.$data.requestDate,
            appointmentTime: this.$data.requestTime,
            timezone: this.$data.requestTimeZone,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_REQUEST}/${this.$props.request.id}/reschedule`,
            data: reschedule,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<ServiceRequest>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_REQUEST_RESCHEDULED'),
                title: 'Success',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
            this.close();
        }
    }

    private async getRouteDetails(routeId: string, serviceRequest: ServiceRequest) {
        const appointmentTimestamp = DateUtils.convertToUTCInMillis(this.$data.requestDate + ' ' +
        this.$data.requestTime, this.$data.requestTimeZone || this.memberProfile.timezone);
        const isPendingImmediateRequest = (serviceRequest.transportRequest &&
            serviceRequest.transportRequest.isImmediateRequest && serviceRequest.status === 'Pending') ? true : false;
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_ROUTES}/${this.routeId}`,
            };
        const response = await iHttpService.get<Route>(apiRequest);
        if (response.success && response.data) {
            const route = response.data;
            let pickUpTime;
            let expectedArrivalTime;
            if (serviceRequest.transportRequest && serviceRequest.transportRequest.isImmediateRequest) {
                pickUpTime = appointmentTimestamp;
                route.expectedArrivalTime = pickUpTime + (route.duration ? route.duration : 0);
            } else {
                expectedArrivalTime = appointmentTimestamp - DateUtils.convertMinutesToMillis(30);
                pickUpTime = expectedArrivalTime - (route.duration ? route.duration : 0)
                 - DateUtils.convertMinutesToMillis(5);
            }
            const oldPickupTime = route.pickupTime ? route.pickupTime : 0;
            const oldPickUpTimeDiff = DateUtils.convertMillisToHours(oldPickupTime -
                                    DateUtils.getCurrentUTCTimeInMillis());
            const timeDifferenceInHour = DateUtils.convertMillisToHours(pickUpTime -
                                    DateUtils.getCurrentUTCTimeInMillis());
            if ( appointmentTimestamp < DateUtils.getCurrentUTCTimeInMillis() ) {
                this.lastMinuteRequest = false;
            } else if (timeDifferenceInHour < 2 && (oldPickUpTimeDiff > 1) &&
             !isPendingImmediateRequest && oldPickupTime > DateUtils.getCurrentUTCTimeInMillis()) {
                    this.lastMinuteRequest = true;
            }
        }
    }

    private async rescheduleLastMinuteRequest() {
        this.confirmReschedule = true;
        await this.rescheduleRequest();
    }
}
